<div class="wccard p-3 mb-1">
  <app-talent-insights-ai [requestaidata]="locationsdataAI" [jobDemandCount]="hasJobDemand" [insightstabname]="'location'" [dataPending] = "getDataPendingStatus()"
    [totalcount]="totalCount"></app-talent-insights-ai>
</div>
<div class="wccard p-3 mb-1">
  <div>
    <p class="f-16 font-weight-600 mb-4">How are their employees spread out?</p>
    <div class="row">
      <div class="col">
        <div class="loader text-center" *ngIf="!dataSourceWorkCountry?.length">
          <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
        </div>
        <div id="workCountryChart" style="height: 500px;"
          [hidden]="!(dataSourceWorkCountry && dataSourceWorkCountry?.length)"></div>
      </div>
    </div>
    <hr class="HR-seperator-in-card">
  </div>

  <!-- <div class="mb-4 float-right">
         <select data-testid="auto-app-report-location-tab-select-1" name="currency" (change)="filterByStatus($event, 'jobtitle')" class="new-form no-shadow wc-select f-12"
                                                                    [(ngModel)]="currency">
                          <option value="USD" selected>USD</option>
                          <option value="INR">INR</option>
                      </select>
    </div> -->

  <div class="mt-2">
    <div class="loader text-center" *ngIf="!locations?.data?.length">
      <div class="loader text-center" *ngIf="!locationAPiCalled">
        <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
      </div>
      <div *ngIf="locationAPiCalled">
        <p class="text-center small p-5 text-484b59">No Data Available</p>
      </div>
    </div>
    <table mat-table *ngIf="locations?.data?.length" [dataSource]="locations" class="mat-elevation-z8"
      style="width: 100%; box-shadow: none;" matSort #locationTbSort="matSort" (matSortChange)="manualSort()">

      <!-- key -->
      <ng-container matColumnDef="key">
        <th mat-header-cell mat-header-cell *matHeaderCellDef class="col-4">
          <p class="text-9696 f-12 m-0">{{tableHeaderObj['TopCities']}}</p>
        </th>
        <td class="text-484b59" mat-cell *matCellDef="let element" style="font-family: 'Poppins', sans-serif;">
          {{element.key | titlecase}}
        </td>
      </ng-container>

      <!-- doc_count -->
      <ng-container matColumnDef="doc_count">
        <th class=" text-center col-2" *matHeaderCellDef mat-header-cell mat-sort-header
          sortActionDescription="Sort by doc count">
          <p class="text-9696 f-12 m-0">{{tableHeaderObj['TalentCount']}}</p>
        </th>
        <td mat-cell *matCellDef="let element" class="text-484b59 font-weight-600">
          <span class="pointer"
            (click)="handelRedirection('location', element.key)">{{element.doc_count | number}}</span>
        </td>
      </ng-container>

      <!-- Recent hires -->
      <ng-container matColumnDef="recent_hires">
        <th class=" text-center col-2" *matHeaderCellDef mat-header-cell mat-sort-header
          sortActionDescription="Sort by count of recenthires">
          <p class="text-9696 f-12 m-0">{{tableHeaderObj['1yrGrowth']}}</p>
        </th>
        <td mat-cell *matCellDef="let element" class="text-484b59 font-weight-600">
          <span class="pointer"
            (click)="handelRedirection('recent_hires', element.key)">{{element.recenthires | number}}</span>
        </td>
      </ng-container>

      <!-- Job Demand -->
      <ng-container matColumnDef="job_doc_count">
        <th class="col-2" *matHeaderCellDef mat-header-cell>
          <p class="text-9696 f-12 m-0" [ngbTooltip]="jobdemand" >{{tableHeaderObj['JobDemand']}}</p>
                  <ng-template #jobdemand>
                      <p class="f-12 font-weight-600 mb-1">About Job Post Metrics</p>
                      <p class="f-12 mb-1">Job post data is sourced directly from company career pages and official employer sites, ensuring high accuracy and active demand.</p>
                      <p class="f-12">Job post and salary metrics are influenced by Job Titles, Skills, Location, Industry, Company, Seniority, and Function. Changes to other filters (e.g., education, gender, experience) do not impact these values.</p>
                    </ng-template>
        </th>
        <td mat-cell *matCellDef="let element" class="text-484b59 font-weight-600 f-12" >
          <div *ngIf="hasJobDemand" class="spinner-border position-absolute text-black" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <span class="" *ngIf="element?.job_doc_count != 0" (click)="hasJobListingAccess && openJoblistSlider(element.key)" [style.cursor]="hasJobListingAccess ? 'pointer' : 'default'">{{element?.job_doc_count | number}}</span>
        <span class="" *ngIf="!element?.job_doc_count" style="font-family: Arial, sans-serif;">&mdash;</span>


        </td>
      </ng-container>

      <ng-container matColumnDef="median_salary">
        <th class="col-2" *matHeaderCellDef mat-header-cell>
          <p class="text-9696 f-12 m-0" ><span [ngbTooltip]="mediansalarytooltip">{{tableHeaderObj['MedianSalary']}}</span>
            <span class="dropdown ats-dropBtn ml-2">

              <span class="dropdown-toggle text-webbtree-green f-14" type="button" id="userDropdownButton" (click)="clearCurrency()"
                appDropdownToggle><i class="fa-solid {{target_fav_icon}}" *ngIf="target_fav_icon != 'fa-money-bill'"></i>
                {{target_fav_icon == 'fa-money-bill' ? currency : ''}}
                <span class="down ml-1"><i class="far fa-angle-down font-weight-300 f-14 pointer"></i></span>
</span>
              <span class="dropdown-menu" aria-labelledby="userDropdownButton"
                style="width: -webkit-fill-available; padding: 10px;">
                <div class="search-input">
                  <i class="fa-solid fa-magnifying-glass search-icon"></i>

                  <input data-testid="auto-app-report-location-tab-input-1" class="wc-form-control no-shadow w-100 inputheight mb-0 mt-0 mx-0" placeholder="Currency"
                     [(ngModel)]="currency" (keyup)="onTypeAheadSearch($event)"
                    (keydown.tab)="handleTabOpen($event)" />
                </div>

                <div *ngIf="filteredCurrencies?.length">
                  <span class="dropdown-item pointer d-flex align-items-center f-14 font-weight-400"
                    *ngFor="let cl of filteredCurrencies" (click)="selectedItem(cl)"
                    style="padding: 10px 10px!important;">
                    {{ cl.target_currency }}
                  </span>
                </div>
              </span>
            </span>
                 <ng-template #mediansalarytooltip>
                      <p class="f-12 font-weight-600 mb-1">About Salary Estimates</p>
                      <p class="f-12 mb-1">Salary range is based on employer-declared compensation shared in job postings. This reflects market-reported averages and may not capture privately negotiated or undisclosed salary bands.</p>
                      <p class="f-12">Salary and job post metrics are influenced by Job Titles, Skills, Location, Industry, Company, Seniority, and Function. Changes to other filters (e.g., education, gender, experience) do not impact these values.</p>
                    </ng-template>
          </p>

        </th>
        <td mat-cell *matCellDef="let element" class="text-484b59 font-weight-600 f-12">
          <div *ngIf="hasMedianSalary" class="spinner-border position-absolute text-black" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <span *ngIf="element?.median_salary != 'N/A'" class="" [innerHTML]="element.median_salary"  ></span>
          <span *ngIf="(element?.confidence_score == 'very high' || element?.confidence_score == 'high')" matTooltip='{{element?.confidence_score | titlecase}} confidence'
            [matTooltipClass]="{ 'small-tooltip text-black': true }"><i
              class="fa-sharp fa-solid fa-shield-check ml-1" style="color: #2E93A1;"></i></span>
          <p *ngIf="element?.median_salary == 'N/A'"
            matTooltip='We’re actively expanding salary coverage for this role. More data will be available as market signals strengthen.'
            [matTooltipClass]="{ 'small-tooltip text-black': true }" style="font-family: Arial, sans-serif;">&mdash;</p>

        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>


</div>

<div class="d-flex justify-content-center wccard ng-star-inserted" *ngIf="totalCount > 10">
  <ngb-pagination [collectionSize]="totalCount <=50 ? totalCount : 50" [maxSize]="5" aria-label="Custom pagination" [pageSize]="pageSize"
    rotate="false" (pageChange)="setPage($event)" [(page)]="currentPage" [ellipses]="false"  [boundaryLinks]="false"
  [directionLinks]="false">
  </ngb-pagination>
</div>

  <app-insights-joblist [data]="toOpenSliderFromTabSubject.asObservable()" [events]="sendDataToSliderSubject.asObservable()"></app-insights-joblist>
